const handleTogglerClick = (e: MouseEvent) => {
  const target = e.currentTarget as HTMLElement;
  const header = target.closest('.header');
  const actives = header?.querySelectorAll('.active');
  target.classList.toggle('active');
  header.classList.toggle('active');
  document.body.classList.toggle('noscroll');

  setTimeout(() => {
    actives.forEach((active) => {
      active.classList.remove('active');
    });
  }, 200);
};

const init = (toggler: HTMLElement) => {
  toggler.addEventListener('click', (e: MouseEvent) => handleTogglerClick(e));
};

export default init;
